// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"365":"3bbec850","674":"e41ced57"}[chunkId] + ".chunk.css";
};